import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import BaselineCostsCard from "components/Next/RealityCheck/BaselineCostsCard";

import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";

class BaselineCostsCardContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <BaselineCostsCard {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const retId = ownProps.runId;

  return {
    updateBaselineConversionGain: (runId, conversionGain) => {
      dispatch(setupReducer.updateBaselineConversionGain(runId, conversionGain));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineConversionCost: (runId, conversionCost) => {
      dispatch(setupReducer.updateBaselineConversionCost(runId, conversionCost));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineConversionMissed: (runId, conversionMissed) => {
      dispatch(setupReducer.updateBaselineConversionMissed(runId, conversionMissed));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineConversionSaved: (runId, conversionSaved) => {
      dispatch(setupReducer.updateBaselineConversionSaved(runId, conversionSaved));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineCustomValue: (runId, blueprintId, customKey, customValue) => {
      dispatch(setupReducer.updateBaselineCustomValue(runId, blueprintId, customKey, customValue));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    removeBaselineCustomValuesMultipleSegments: (runIdArray, blueprintId, overallRunId) => {
      dispatch(setupReducer.removeBaselineCustomValuesMultipleSegments(runIdArray, blueprintId, overallRunId));
    },
    updateShowBaselines: (showBaselines) => {
      dispatch(projectReducer.updateShowBaselines(ownProps.id, showBaselines));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const runId = ownProps.runId;

  return {
    setup: setupReducer.getSetup(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(BaselineCostsCardContainer);
